import { Helmet } from 'react-helmet-async';
import { FeaturesView } from 'src/sections/features/view';

export default function FeaturesPage() {
  return (
    <>
      <Helmet>
        <title>Features - Cartify</title>
      </Helmet>
      <FeaturesView />
    </>
  );
}
